<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="30%" :before-close="handleClose" class="dialogEdit">
     <el-form :model="form">
          <el-form-item label="名称">
            <el-input placeholder="请输入名称" v-model="form.nickname"></el-input>
          </el-form-item>
           <!-- <el-form-item label="帳戶">
            <el-input placeholder="請輸入手機號" v-model="form.mobile"></el-input>
          </el-form-item>
           <el-form-item label="密碼">
            <el-input placeholder="請輸入密碼" v-model="form.password" type="password"></el-input>
          </el-form-item> -->
         
        </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "author_dialog",
  data() {
    return {
      dialogVisible: false,
      formLabelWidth: 30,
      title:"添加人员",
      form: {
        nickname: "",
        id: "",
      }
    };
  },
  methods: {
    show(value) {
      this.dialogVisible = true;
      if (value !== undefined) {
          this.title = "编辑人员";
        this.form = Object.assign({}, value);
      } else {
        this.title = "添加人员";
        this.form = { nickname: "", id:"" };
      }
    },
    onSubmit() {
      var self = this;
      let params = Object.assign({}, this.form);
      this.$http.post("/admin/manager/adduser", params).then(res => {
        self.$emit("sucess");
        this.dialogVisible = false;
      });
    }
  }
};
</script>
<style lang="less">
.dialogEdit{
    text-align:left;
    
}
</style>